import React from 'react';
import { Oval } from 'react-loader-spinner';

const Loader = () => {
  return (
    <div style={styles.loaderContainer}>
     
        <Oval
          visible={true}
          height="60"
          width="60"
          strokeWidth={5}
          // secondaryColor='#192849'
          color="#69A8DF"
          // strokeWidthSecondary={"red"}
          ariaLabel="oval-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
     
    </div>
  );
};

const styles = {
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'transparent', 
    zIndex: 9999,
  }
};

export default Loader;
